import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../../utils/axios";

const initialState = {
    totalRegistrations: 0,
    totalTicketsSold: 0,
    totalCheckIns: 0,
    pendingCheckIns: 0,
    attendees: [],
    attendance: []
}

const registrationSlice = createSlice({
    name: "registrations",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(getAttendeeRegistrations.fulfilled, (state, action) => {
                const responseData = action.payload?.data || {};
                const groupTicket = responseData?.attendees?.filter(attendee => attendee.parent_id).length || 0;

                state.attendees = responseData?.attendees || [];
                state.totalRegistrations = responseData?.attendees?.length || 0;
                state.totalTicketsSold = state.totalRegistrations - groupTicket;
            })

            .addCase(getAttendanceList.fulfilled, (state, action) => {

                const responseData = action.payload?.data || {};
                const records = responseData?.records || [];

                state.attendance = records;

                const checkedInTickets = [];

                records.forEach(record => {
                    const scanHistory = record?.scan_history || [];
                    const hasCheckedIn = scanHistory.some(scan => scan.action === "checked_in");

                    if (hasCheckedIn) {
                        checkedInTickets.push(hasCheckedIn);
                    }
                });

                state.totalCheckIns = checkedInTickets.length;
                state.pendingCheckIns = state.totalRegistrations - checkedInTickets.length;

            })
    }
})

export const { } = registrationSlice.actions;

export default registrationSlice.reducer;


/**
 * @async
 * @function getAttendeeRegistrations
 * @description Fetches the list of attendee registrations for a specific event. (Who have bought tickets)
 * @param {string} eventId - The ID of the event for which to fetch attendee registrations.
 * @returns {Promise<Object>} - A promise that resolves to the response data containing attendee registrations.
 * @throws {Object} - An error object containing error details if the request fails.
 * 
 * @example
 * dispatch(getAttendeeRegistrations(eventId))
 */
export const getAttendeeRegistrations = createAsyncThunk(
    "registrations/getAttendeeRegistrations",
    async (eventId, { rejectWithValue }) => {
        try {
            const backendResponse = await axios.get(`/api/v2/event/registrations/${eventId}`);

            const response = {
                ...backendResponse?.data,
                code: backendResponse?.status
            }

            return response;
        } catch (error) {
            return rejectWithValue({
                ...error?.data,
                code: error?.status
            });
        }
    }
);


/**
 * @async
 * @function getAttendanceList
 * @description Fetches the attendance list for a specific event.
 * @param {string} eventId - The ID of the event for which to fetch the attendance list.
 * @returns {Promise<Object>} - A promise that resolves to the response data containing the attendance list.
 * @throws {Object} - An error object containing error details if the request fails.
 * 
 * @example
 * dispatch(getAttendanceList(eventId))
 */
export const getAttendanceList = createAsyncThunk(
    "registrations/getAttendanceList",
    async (eventId, { rejectWithValue }) => {
        try {
            const backendResponse = await axios.get(`/api/v2/event/attendance/${eventId}`);

            const response = {
                ...backendResponse?.data,
                code: backendResponse?.status
            }

            return response;
        } catch (error) {
            return rejectWithValue({
                ...error?.data,
                code: error?.status
            });
        }
    }
);